import React, { useState } from 'react';
import './Landing.css';
import BrandFooter from '../components/BrandFooter';

// Hero artwork (cat + 게임이냥 lockup). Loaded from /public/assets/ so the
// build never fails when the file is absent — a placeholder shows instead.
//   museumx/frontend/public/assets/gameinyang_logo2.png
const HERO_SRC = `${process.env.PUBLIC_URL}/assets/gameinyang_logo2.png`;

// Start screen (status active, user not yet registered).
const Landing = ({ onStart }) => {
  const [heroFailed, setHeroFailed] = useState(false);

  return (
    <div className="landing-container">
      <div className="landing-content">
        <div className="hero-container">
          {heroFailed ? (
            <div className="hero-fallback">
              [ Place gameinyang_logo2.png in<br />
              public/assets/ ]
            </div>
          ) : (
            <img
              src={HERO_SRC}
              alt="게임이냥"
              className="hero-img"
              onError={() => setHeroFailed(true)}
              draggable={false}
            />
          )}
        </div>

        <div className="start-button-wrap">
          <button type="button" className="start-button" onClick={onStart}>
            <span className="start-button-text">START</span>
          </button>
        </div>
      </div>

      <BrandFooter />
    </div>
  );
};

export default Landing;
